export const ADDPRODUCT = "prod/addProduct";
export const ADDCART = "prod/addCart";
export const UPDATEHEADER = "prod/updateHeader";
export const PRODQUETYINCREMENT = "prod/quetyIncrement";
export const PRODQUETYDECREMENT = "prod/quetyDecrement";
